import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const SCHEDULE_RELIABILITY_FILTERS = REPORTS_DEFAULT_FILTERS

export const SCHEDULE_RELIABILITY_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'percent' | 'count'
  unitInline?: string
}> = [
  {
    id: 'no-show-rate',
    title: 'No-Show Rate',
    footer: 'No-shows / scheduled appointments',
    format: 'percent',
  },
  {
    id: 'cancellation-rate',
    title: 'Cancellation Rate',
    footer: 'Cancellations / appointments',
    format: 'percent',
  },
  {
    id: 'no-show-count',
    title: 'No-Show Count',
    footer: 'Events',
    format: 'count',
    unitInline: 'Events',
  },
  {
    id: 'repeat-offenders',
    title: 'Repeat Offenders',
    footer: 'Patients',
    format: 'count',
    unitInline: 'Patients',
  },
]

export type RepeatOffenderRow = {
  id: string
  patientName: string
  noShows: number
  eligible: number
  completed: string
}

export type NoShowPatientRow = {
  id: string
  patientName: string
  date: string
  provider: string
  procedure: string
  phone: string
}
